__turbopack_context__.v({
  "switcher": "WixStudioToolBar-module-scss-module__ObxhFG__switcher",
  "wixStudioToolBar": "WixStudioToolBar-module-scss-module__ObxhFG__wixStudioToolBar",
  "wixStudioToolBarMobile": "WixStudioToolBar-module-scss-module__ObxhFG__wixStudioToolBarMobile",
});
